import { Input as HeadlessUiInput } from "@headlessui/react"
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/solid"
import { useState } from "react"
import { useTranslation } from "react-i18next"

interface Props {
  autoFocus?: boolean
  invalid?: boolean
  name?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export default function PasswordInput({
  autoFocus = false,
  invalid = false,
  name,
  onChange,
}: Props) {
  const [hidePassword, setHidePassword] = useState(true)

  const { t } = useTranslation()

  return (
    <div className="relative flex items-center">
      <HeadlessUiInput
        autoFocus={autoFocus}
        className="theme-input pr-14"
        invalid={invalid}
        name={name}
        onChange={onChange}
        placeholder={t("shared.password")}
        type={hidePassword ? "password" : "text"}
      />

      <button
        className="absolute right-0 flex h-full items-center pr-5"
        onClick={() => setHidePassword(!hidePassword)}
        type="button"
      >
        {hidePassword ? (
          <EyeSlashIcon className="text-custom-gray h-5 w-5" />
        ) : (
          <EyeIcon className="text-custom-gray h-5 w-5" />
        )}
      </button>
    </div>
  )
}
